module.exports = __webpack_public_path__ + "img/Pasos.21c6a66c.svg";